module.exports = __webpack_public_path__ + "static/img/cp1.71045c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp1.png
// module id = gXaP
// module chunks = 1